import React from "react";
import ReactDOM from "react-dom";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import RouterApp from "router/RouterApp";
import { store, history, persistor } from "./redux/store/index";
import { ThemeWrapper } from "./ThemeWrapper";
import { readThemeMode } from "helpers/themeMode";

import "assets/scss/material-dashboard-pro-react.scss?v=1.8.0";
import "./utils/globalStyles.css";
import "animate.css";
import "react-datepicker/dist/react-datepicker.css";

// Bounce back AWS SSO iframe redirects
if (
  window !== window.parent &&
  window.name === "amazon--connect" &&
  window.location.pathname !== "/connect.html"
) {
  window.location.replace("/connect.html");
}

// Aplica el tema guardado antes del primer render para evitar el destello en claro;
// ThemeWrapper lo mantiene sincronizado cuando el usuario cambia de tema.
const initialThemeMode = readThemeMode();
document.body.setAttribute("data-theme", initialThemeMode);
document.documentElement.setAttribute("data-theme", initialThemeMode);

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ConnectedRouter history={history}>
        <ThemeWrapper>
          <RouterApp />
        </ThemeWrapper>
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  document.getElementById("root"),
);
